$ = require 'jquery'
b = require 'lib/browser-detect'
{ isEmbeddedDocument } = require 'common/lib/util/browser'

module.exports = new class

  constructor: ->
    @browserStr = b.browser.toLowerCase()
    # Safari returns versions like 10.1
    @browserVersionStr = "#{b.browser}-#{b.version}".toLowerCase().replace(/\.\d+$/, '')
    @osStr = b.OS.toLowerCase()
    @asString = "#{@browserStr} #{@browserVersionStr} #{@osStr}"
    $ => $('#classic-body').addClass(@asString)
    @isEmbeddedDocument = isEmbeddedDocument

  remount: ->
    @browserStr = b.browser.toLowerCase()
    # Safari returns versions like 10.1
    @browserVersionStr = "#{b.browser}-#{b.version}".toLowerCase().replace(/\.\d+$/, '')
    @osStr = b.OS.toLowerCase()
    @asString = "#{@browserStr} #{@browserVersionStr} #{@osStr}"
    $ => $('#classic-body').addClass(@asString)

  isTouch: ->
    @isAndroid() || @isIos()

  isAndroid: ->
    @osStr == 'android'

  isIos: ->
    @osStr in ['ipad', 'iphone']

  isHighDPI: -> window.devicePixelRatio > 1

  allowsDynamicFavicon: ->
    @browserStr in ['chrome', 'firefox']

  detectCustomWebkitScrollbars: ->
    try
      $('::-webkit-scrollbar')
      className = 'body-webkit-scrollbars'
    catch
      className = 'body-no-webkit-scrollbars'
    finally
      $('#classic-body').addClass className



// WEBPACK FOOTER //
// ./app/scripts/lib/browser.coffee